import React from "react";
import { OtherTreatmentsScreen } from "./OtherTreatmentsScreen";

export function UnknownTreatmentsScreen() {
  return <OtherTreatmentsScreen mode="unknown" />;
}

export default UnknownTreatmentsScreen;
